exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-768657f7] .el-tabs__header{margin-bottom:0}[data-v-768657f7] .el-button+.el-button.e-btn{margin-left:0}[data-v-768657f7] .el-button-group .el-button--primary:first-child{border-right-color:#b3d8ff}[data-v-768657f7] .el-button-group>.el-button:not(:last-child){margin-right:0}", ""]);

// exports
